export default (attribute) => {
    return attribute.split('.')[0]
};
